/**
 * Stripe Configuration
 * 
 * Test Mode Publishable Key - Safe to expose in frontend
 * Get your test keys from: https://dashboard.stripe.com/test/apikeys
 */

// This is a Stripe TEST key - it's safe to commit and won't charge real money
export const STRIPE_PUBLISHABLE_KEY = 'pk_test_ua6y4JHhmMgEqp8tvzbO2BQj';

// Test card numbers for testing
export const TEST_CARDS = {
  SUCCESS: '4242424242424242',
  DECLINED: '4000000000000002',
  REQUIRES_AUTH: '4000002500003155',
  INSUFFICIENT_FUNDS: '4000000000009995'
};

export const STRIPE_CONFIG = {
  // Any future expiry date works in test mode
  testExpiry: '12/34',
  // Any 3-digit CVV works in test mode
  testCVV: '123',
  // Any billing zip works in test mode
  testZip: '12345'
};
